import axios from "axios";
import Swal from 'sweetalert2';

const state = {
  allocList: [], 
  allocArr: [],
  allocArray: [],
  allocationID: '',
  selectedAllocation: null,
  selectedProject: null,
  selectedEmployee: null,
  isEditing: false
};
  
const mutations = {
  initializeStore(state){
    state.allocList = [];
    state.allocArr = [];
    state.allocArray = [];
    state.allocationID = "";
    state.selectedAllocation = null;
    state.selectedProject = null;
    state.selectedEmployee = null;
    state.isEditing = false;
  },
  SET_SELECTED_ALLOCATION(state, allocation) {
    state.selectedAllocation = allocation;
    state.isEditing = true;
  },
  LIST_PROJECT_ALLOCATIONS(state, projects) {
    state.allocList = projects;
  },
  PROJECTS_ARRAY(state, projects){
    state.allocArray = projects;
  },
  SET_SELECTED_PROJECT(state, project) {
    state.selectedProject = project;
  },
  SET_SELECTED_EMPLOYEE(state, employee) {
    state.selectedEmployee = employee;
  },
  SET_STATE(state, payload) {
    for (const key in payload) {
        if (payload.hasOwnProperty(key) && key in state) {
            state[key] = payload[key];
        }
    }
  },
  SET_SEARCH_FILTERS(state, search_filter){
    for(const [key, value] of Object.entries(search_filter)){

    }
  },
  RESET_SEARCH_FILTERS(state){

  }
};
  
const actions = {
  updateState({ commit }, newState) {
    commit('SET_STATE', newState);
  },
  
  async createProjectAllocation({ commit,state }, formData) {
    return axios.post('api/v1/create-project-allocation/', formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      throw error;
    })
  },

  fetchProjectAllocations({ commit,state }, formData) {
    state.allocArr = [];
    axios.post(`api/v1/get-project-allocations/`,formData)
    .then((response)=>{
      for(let i=0; i< response.data.length; i++){
        state.allocArr.push((response.data[i].employee.employee_name + " - " +  response.data[i].project.name));
      }
      commit('LIST_PROJECT_ALLOCATIONS', response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  fetchProjectAllocation({ commit,state }, formData) {
    axios.post(`api/v1/get-project-allocations/`,formData)
    .then((response)=>{
      state.selectedAllocation = response.data;
      const selectedEmployee = response.data.employee.staff_number + " - " + response.data.employee.employee_name;
      commit('SET_SELECTED_PROJECT',response.data.project.name);
      commit('SET_SELECTED_EMPLOYEE', selectedEmployee);
      commit('SET_SELECTED_ALLOCATION', response.data)
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  handleSelectedProjectAllocation({ commit, state }, option){
    const selectedProject = state.allocList.find(allocation => (allocation.employee.employee_name + " - " +  allocation.project.name ) === option);
    if (selectedProject) {
        state.allocationID = selectedProject.project_allocation_id;
        state.allocArray = [...state.allocArray, selectedProject];
    }
    commit('PROJECTS_ARRAY', state.allocArray);
      
  },
  async updateProjectAllocation({ commit,state }, formData) {
    return axios.put(`api/v1/update-project-allocation/`,formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })  
  },

  deleteProjectAllocation({ commit,state }, formData) {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you wish to delete Allocation?`,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes Delete Allocation!',
      cancelButtonText: 'Cancel!',
      customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom',
      },
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.value) {
        axios.post(`api/v1/delete-project-allocation/`,formData)
        .then((response)=>{
          if(response.status == 200){
              Swal.fire("Poof! Allocation removed succesfully!", {
                icon: "success",
              }); 
          }else{
            Swal.fire({
              title: "Error Deleting Allocation",
              icon: "warning",
            });
          }                   
        })
        .catch((error)=>{
          console.log(error.message);
          Swal.fire({
            title: error.message,
            icon: "warning",
          });
        })
      }else{
        Swal.fire(`Allocation has not been deleted!`);
      }
    })
  },

};
  
const getters = {
  // users: (state) => state.users,
  // currentUser: (state) => state.currentUser,
};
  
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  
  